/* eslint-disable  prefer-promise-reject-errors */
import axios, { Method, AxiosResponse } from 'axios'
import { message } from 'antd'
import { verifyAppTokenValid, verifyExamine, getLang, getAppToken, expiredAppTokenValid } from '@console/utils/index'

export interface IParams {
  method?: Method
  headers?: any
  baseURL?: string
  params?: any
  data?: any | string
}

function checkStatus(response: AxiosResponse) {
  let notAuth = ''
  let fail = ''
  let serviceError = ''
  if (getLang() === 'en') {
    notAuth = 'Please complete your developer certification first'
    fail = 'Request error'
    serviceError = 'Server error'
  } else {
    notAuth = '请先完成开发者认证'
    fail = '请求错误'
    serviceError = '服务器错误'
  }

  const { status, data } = response
  if (status >= 200 && status < 300) return data || { success: true }
  // 根据status做不同处理
  let error: Error
  if (status === 401 || status === 403) {
    error = new Error(notAuth)
  } else if (status >= 400 && status < 500) {
    error = new Error(fail)
  } else {
    error = new Error(serviceError)
  }
  error.name = status.toString()
  if (status !== 404) throw error
}

// 接口请求SDK
export default function request(url: string, params: IParams = {}, option = { needCatch: true, needVerifyToken: true, needVerifyExamine: false }) {
  const { needCatch, needVerifyToken, needVerifyExamine } = option
  const apptoken = getAppToken()
  const examineType = localStorage.getItem('examineType') || ''
  if (needVerifyToken) {
    if (!apptoken) {
      verifyAppTokenValid()
      return Promise.reject()
    }
    if (needVerifyExamine && Number(examineType) !== 2) {
      verifyExamine()
      return Promise.reject()
    }
  }
  const defaultHeaders = {
    apptoken
  }
  const headers = params.headers ? params.headers : {}

  const req = axios({
    method: params.method || 'get',
    url,
    headers: { ...defaultHeaders, ...headers },
    params: params.params,
    data: params.data,
    validateStatus() {
      return true
    }
  })
  if (needCatch) {
    return req.then(checkStatus).catch((err: Error) => {
      // eslint-disable-next-line no-useless-return
      if (err.name === '401') return { error: err }
      message.error(err.message)
    })
  }
  return req.then((response) => {
    return new Promise((resolve, reject) => {
      const { status, data } = response
      if (status >= 200 && status < 400) {
        resolve(data)
      } else if (status === 401) {
        expiredAppTokenValid()
      } else {
        reject({ ...data, status })
      }
    })
  })
}
